import * as Config from '../../../config';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, useRouteMatch, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import './Genres.css';

import List from './List';
import GenreV2 from './GenreV2'; //'./Genre';
import Empty from './Empty';

import useGetFromApi from '../../../hooks/useGetFromApi';
import usePageScroll from '../../../hooks/usePageScroll';

function ConnectedGenresManager({ dimension, user, style, storeRoute }) {
  const [response] = useGetFromApi(`genres`, `/catalog/genres/`);
  let { path, url } = useRouteMatch();
  const { width, height } = dimension;
  const globalHistory = useHistory();

  const items = response ? response.items : null;

  const get = (slug, type) => {
    const item = (items) ? items.find(x => x.slug === slug) : null;
    return item ? item[type] : null;
  }

  let { onScroll } = usePageScroll();

  useEffect(() => {
    if (storeRoute && !Config.GENRES_HAS_CUSTOM_EMPTY && path === '/genres' && items && items.length > 0) { 
      storeRoute.goTo(`/genres/${items[0]['slug']}`);
    }
  }, [path, storeRoute, items])
  
  return (
    <div className={`flexRow genres-page`} style={{ height, ...style }} onScroll={onScroll}>
      <div className={`card-container genres`} style={{ height: height - Config.GRID_PAD }}>
        <List items={items} uri={url} location={globalHistory.location.pathname} />
      </div>
      <div className={`content-container genres`} style={{
        width : width - Config.SUB_SIDEBAR + 16,
        height: height - Config.TAB_BAR_GUTTER
      }}>
        <Switch>
          <Route path={`${path}/:genreSlug`} render={ props => {
            return (items && get(props.match.params.genreSlug, `id`))
              ? <GenreV2 id={get(props.match.params.genreSlug, `id`)} name={get(props.match.params.genreSlug, `name`)} 
                  search={get(props.match.params.genreSlug, `search`)} 
                  notsearch={get(props.match.params.genreSlug, `notsearch`)}
                />
              : null
          }} />
          { (Config.GENRES_HAS_CUSTOM_EMPTY && user && user.genres.length === 0 ) && (
            <Route exact path={`/genres`} >
              <Empty />
            </Route>
          ) }
        </Switch>
      </div>
    </div>
  )
}

ConnectedGenresManager.propTypes = {
  style: PropTypes.object
}

const GenresManager = connect(
  state => ({
    dimension: state.dimension,
    user: state.user,
    storeRoute: state.storeRoute
  })
)(ConnectedGenresManager);

export default GenresManager;
